export default "__VITE_ASSET__Ca2JLXBH__"